import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { MomentModule } from 'angular2-moment';
import { SimpleNotificationsModule } from 'angular2-notifications';
// import { DatepickerModule } from '@novalinc/datepicker';
import { DashboardWhatWeTreat } from './dashboard/dashboard-what-we-treat';
import { BHWhatWeTreat } from './behavior-health/bh-what-we-treat';
import { PsychiatryWhatWeTreat } from './dashboard/psychiatry-what-we-treat';
import { DashboardPricing } from './dashboard/dashboard-pricing';
import { BHPricing } from './behavior-health/bh-pricing';
import { DashboardPrescriptionPolicy } from './dashboard/dashboard-prescription-policy';
import { BHPrescriptionPolicy } from './behavior-health/bh-prescription-policy';
import { DashboardOurProviders } from './dashboard/dashboard-our-providers';
import { DashboardHowItWorks } from './dashboard/dashboard-how-it-works';
import { BHHowItWorks } from './behavior-health/bh-how-it-works';


import { BHOurProviders  } from './behavior-health/bh-our-providers';
import { BHKnowMore } from './behavior-health/bh-know-more';
 

import { AppComponent } from './app.component';
import { AppRouting } from './app.routing';
import { AuthGuard } from './guards/auth.guard';
import { BHScreenWhatToExpect } from './behavior-health/bh-screen-what-to-expect';
import { BreadcrumbComponent } from "./components/breadcrumb";

import { DashboardComponent } from './dashboard/dashboard';
import { DashboardExamHistoryComponent } from './dashboard/dashboard-exam-history';
import { DashboardBHScreenComponent } from './dashboard/dashboard-bh-screen';
import { DashboardFamilyComponent } from './dashboard/dashboard-family';
import { DashboardMedicalHistoryComponent } from './dashboard/dashboard-medical-history';
import { DashboardMedicalComponent } from './dashboard/dashboard-medical';
import { DashboardMyProfileComponent } from './dashboard/dashboard-my-profile';

import { Environment } from './app.environment';
import { ExamAppointment } from './exam/exam-appointment';
import { ExamCompleteComponent } from './exam/exam-complete';
import { ExamFormOfPayment } from './exam/exam-form-of-payment';
import { ExamHaveAllergies } from './exam/exam-have-allergies';
import { ExamHistoryPatientComponent } from './exam/exam-history-patient';
import { ExamRequestComponent } from './exam/exam-request';
import { ExamRequestCareToday } from './exam/exam-request-care-today';
import { ExamReviewRequest } from './exam/exam-review-request';
import { ExamReasonForExam } from './exam/exam-reason-for-exam';
import { ExamSelectPharmacy } from './exam/exam-select-pharmacy';
import { ExamSurveyComponent } from './exam/exam-survey';
import { ExamTakingAnyMedications } from './exam/exam-taking-any-medications';
import { ExamThankYouComponent } from './exam/exam-thankyou';
import { ExamUploadFile } from './exam/exam-upload-file';
import { ExamWhatToExpect } from './exam/exam-what-to-expect';
import { FamilyMemberComponent } from './exam/family-member';
import { ForgotPassword } from './forgot-password/forgot-password';
import { AuthPartner } from './authorize/auth.partner';
 

import { LoadingIndicator } from './components/loading-indicator/loading-indicator';
import { LoginComponent } from './login/login';
import { MyModal } from './components/modal/modal';
import { MessagingService, MessagingConfig } from './services/messaging';
import { PendingChangesGuard } from './guards/pending-changes.guard';
import { PhonePipe } from '../assets/pipes/phoneNumber';
import { TextTrimPipe } from '../assets/pipes/textTrim';
import { SafePipe } from './components/safeHtml.component';
import { SignupAddress } from './signup/signup-address';
import { SignupCheckEmail } from './signup/signup-check-email';
import { SignupPassword } from './signup/signup-password';
import { SignupPatient } from './signup/signup-patient';
import { SignupPlan } from './signup/signup-plan';
import { SpinnerComponent } from './components/spinner/spinner';
import { UTCTimeConvert } from '../assets/pipes/utcTimeConvert';
import { VideoSession } from "./components/video/video-session";
import * as $ from 'jquery'; 

import { NgUploaderModule } from 'ngx-uploader';
import { HowToSchedulePage } from './exam/how-to-schedule';
import { SelectProviderPage} from './exam/select-provider';
import { ProviderDetailPage} from './exam/provider-detail';
import { ProviderModule} from './components/provider/provider.module';
import { ScheduleModule, DayService, WeekService, WorkWeekService, MonthService, AgendaService, MonthAgendaService } from '@syncfusion/ej2-angular-schedule';
import { DashboardPaymentsAdd } from './dashboard/dashboard-add-payment';
import { MyAppointmentsComponent } from './my-appointments/my-appointments.component';




import {
  Api,
  ErrorCodes,
  ErrorHelper,
  Session,
  States,
  Ui,
  Utility,
  HardwareCheckerService
} from './services/index';
import { VideoTestComponent } from './components/video-test/video-test.component';
import { MemdNavbarComponent } from './components/memd-navbar/memd-navbar.component';
import { SchedulerComponent } from './components/scheduler/scheduler.component';
import { PsychiatryOurProvidersComponent } from './dashboard/psychiatry-our-providers.component';
import { PsychiatryHowItWorksComponent } from './dashboard/psychiatry-how-it-works.component';
import { PsychiatryPrescriptionPolicyComponent } from './dashboard/psychiatry-prescription-policy.component';
import { PsychiatryPricingComponent } from './dashboard/psychiatry-pricing.component';
import { MyDocumentsComponent } from './my-documents/my-documents.component';


import { AccordionModule } from '@syncfusion/ej2-angular-navigations';
import { SidebarModule } from '@syncfusion/ej2-angular-navigations';
import { CheckBoxModule, RadioButtonModule, SwitchModule, ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { DropDownButtonModule, SplitButtonModule, ProgressButtonModule, } from '@syncfusion/ej2-angular-splitbuttons';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { VirtualizationService,ListViewAllModule } from '@syncfusion/ej2-angular-lists';
import { TextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { TabAllModule } from '@syncfusion/ej2-angular-navigations';
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import { NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import {MatCardModule,
  MatListModule,
  MatExpansionModule} from '@angular/material';

  import {MatIconModule} from '@angular/material/icon';
  import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
  import { TranslateHttpLoader } from '@ngx-translate/http-loader';
  import { HttpClient, HttpClientModule } from '@angular/common/http';
import { DisclosureStatementComponent } from './disclosure-statement/disclosure-statement.component';
  


export function createMessagingConfig() {
  let messagingConfig = new MessagingConfig();
  messagingConfig.url = "http://localhost:49578/";  
  messagingConfig.hubName = "EventHub";
  return messagingConfig;
}
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    BHScreenWhatToExpect,
    BreadcrumbComponent,
    BHPricing,
    BHOurProviders,
    BHHowItWorks,
    BHKnowMore,
    BHPrescriptionPolicy,    
    BHWhatWeTreat,
    DashboardPaymentsAdd,
    DashboardComponent,
    DashboardExamHistoryComponent,
    DashboardBHScreenComponent,
    DashboardFamilyComponent,
    DashboardMedicalComponent,
    DashboardMedicalHistoryComponent,
    DashboardMyProfileComponent,
    DashboardWhatWeTreat,
    DashboardPricing,
    DashboardPrescriptionPolicy,
    DashboardOurProviders,
    DashboardHowItWorks,
    ExamAppointment,
    ExamCompleteComponent,
    ExamFormOfPayment,
    ExamHaveAllergies,
    ExamHistoryPatientComponent,
    ExamRequestComponent,
    ExamRequestCareToday,
    ExamReasonForExam,
    ExamReviewRequest,
    ExamSelectPharmacy,
    ExamSurveyComponent,
    ExamTakingAnyMedications,
    ExamThankYouComponent,
    ExamUploadFile,
    ExamWhatToExpect, 
    FamilyMemberComponent,
    ForgotPassword,    
    AuthPartner,
    LoadingIndicator,
    LoginComponent,
    MyModal,
    PhonePipe,
    TextTrimPipe,
    SafePipe,
    SignupAddress,
    SignupCheckEmail,
    SignupPassword,
    SignupPatient,
    SignupPlan,
    SpinnerComponent,
    UTCTimeConvert,
    VideoSession,
    VideoTestComponent,
    MemdNavbarComponent,
    HowToSchedulePage,
    SelectProviderPage,
    ProviderDetailPage,
    SchedulerComponent,
    PsychiatryWhatWeTreat,
    PsychiatryOurProvidersComponent,
    PsychiatryHowItWorksComponent,
    PsychiatryPrescriptionPolicyComponent,
    PsychiatryPricingComponent,
    MyDocumentsComponent,
    DisclosureStatementComponent,
    MyAppointmentsComponent    
  ],
  imports: [
    AppRouting,
    BrowserModule,
    BrowserAnimationsModule,
    DatePickerModule,
    FormsModule,
    AccordionModule,
    HttpModule,   
    HttpClientModule,
    MomentModule,
    ReactiveFormsModule,
    NgUploaderModule,
    ButtonModule, 
    RadioButtonModule, 
    DropDownButtonModule, 
    SplitButtonModule, 
    ProgressButtonModule, 
    TextBoxModule,
    NumericTextBoxModule,
    SwitchModule,
    MatCardModule,
    MatListModule,
    MatIconModule,
    MatExpansionModule,
    ScheduleModule,
    SidebarModule,
    DropDownListModule,
    MaskedTextBoxModule,
    CheckBoxModule,
    ListViewAllModule,
    DialogModule,
    TabAllModule,
    SimpleNotificationsModule.forRoot(),    
    ProviderModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (HttpLoaderFactory),
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    Api,
    AuthGuard,
    Environment,
    ErrorCodes,
    ErrorHelper,
    MessagingService,
    PendingChangesGuard,
    Session,
    States,
    Ui,
    HttpModule,  
    VideoSession,
    HardwareCheckerService,
    DayService, 
    WeekService, 
    WorkWeekService,
     MonthService, 
     AgendaService,
     MonthAgendaService,
    { provide: 'hub.config', useFactory: createMessagingConfig } ],
  bootstrap: [AppComponent],
  exports:[MatListModule]
})
export class AppModule { }
